// extracted by css-extract-rspack-plugin
var _1 = "c8";
var _2 = "c7";
export { _1 as "noDiscounts", _2 as "shoppingMallTabSavedComponent" }
